import { render, staticRenderFns } from "./card-modal.vue?vue&type=template&id=e84c1d92"
import script from "./card-modal.vue?vue&type=script&lang=js"
export * from "./card-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports